import Decimal from 'decimal.js';

interface ToShortNumFormatOptions {
  fixedCof?: number;
}

const toShortNumFormat = (
  num: number,
  options?: ToShortNumFormatOptions,
): string => {
  const [integerPart] = String(num).split('.');

  const removeExtraZero = (numStr: string): string =>
    numStr.replace(/\.(\d*?[1-9])0+|\.0+$/, '.$1').replace(/\.$/, '');

  if (integerPart === '0') {
    return String(num);
  } else {
    const decimalInteger = new Decimal(integerPart);
    const fixedCof = options?.fixedCof || 1;

    if (integerPart.length >= 10) {
      const formatedValue = decimalInteger
        .div(1000000000)
        .toNumber()
        .toFixed(fixedCof);

      return removeExtraZero(formatedValue) + 'B';
    } else if (integerPart.length >= 7) {
      const formatedValue = decimalInteger
        .div(1000000)
        .toNumber()
        .toFixed(fixedCof);

      return removeExtraZero(formatedValue) + 'M';
    } else if (integerPart.length >= 4) {
      const formatedValue = decimalInteger
        .div(1000)
        .toNumber()
        .toFixed(fixedCof);

      return removeExtraZero(formatedValue) + 'K';
    } else {
      return String(num);
    }
  }
};

const parseShortNumFormat = (
  num: number,
): { value: number; suffix?: string } => {
  const strRes = toShortNumFormat(num);

  if (typeof strRes === 'number') {
    return { value: strRes };
  } else {
    let suffix: string | undefined;
    const lastCharIndex = strRes.length - 1;
    const lastChar = strRes[lastCharIndex];

    if (isNaN(Number(lastChar))) {
      suffix = lastChar;
    }

    return strRes
      ? {
          value: parseFloat(strRes),
          suffix,
        }
      : {
          value: 0,
        };
  }
};

export { parseShortNumFormat, toShortNumFormat };
